/**
 * width -> string = largura
 * height -> string = altura
 * image -> string = imagem dentro de responsive-images
 * path -> string = path dentor de images
 * isPublic -> bool = imagem dentro de public
 */
import React, { useEffect, useState } from "react";
import "./ResponsiveImage.css";
import getImage from "../../useFull/getImage";

const ResponsiveImage = (props) => {
  const { width, height, image, path, isPublic, borderRadius } = props;
  const [calculatedHeight, setCalculatedHeight] = useState(height);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCalculatedHeight(`calc(${height} - 200px)`);
      } else if (window.innerWidth <= 768) {
        setCalculatedHeight(`calc(${height} - 150px)`);
      } else if (window.innerWidth <= 992) {
        setCalculatedHeight(`calc(${height} - 100px)`);
      } else if (window.innerWidth <= 1140) {
        setCalculatedHeight(`calc(${height} - 50px)`);
      } else {
        setCalculatedHeight(height);
      }
    };

    handleResize(); // Calculate initially
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const img = getImage(path || "responsive-images", image, isPublic);
  if (!img) return null;

  return (
    <div
      className={`responsive-image ${borderRadius ? borderRadius : ""}`}
      style={{
        backgroundImage: `url(${img})`,
        width: width || "100%",
        height: calculatedHeight,
      }}
    />
  );
};

export default ResponsiveImage;
